import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("token");
export const setToken = (t) => (t ? localStorage.setItem("token", t) : localStorage.removeItem("token"));

axios.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t && cfg.url?.startsWith(API)) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
axios.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 401 && getToken()) { setToken(null); window.dispatchEvent(new Event("auth:expired")); }
  return Promise.reject(e);
});

export const errMsg = (e, fallback = "Erreur") => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

const enc = encodeURIComponent;
let _saisies = false;
export const setIncludeSaisies = (v) => { _saisies = !!v; };
let _lang = localStorage.getItem("lang") || "fr";
export const setApiLang = (l) => { _lang = l === "en" ? "en" : "fr"; };
const sq = (sep) => `${sep}lang=${_lang}` + (_saisies ? "&saisies=true" : "");

export const deviceId = () => {
  let d = localStorage.getItem("appareil");
  if (!d) { d = (crypto.randomUUID ? crypto.randomUUID() : String(Math.random()).slice(2) + Date.now()); localStorage.setItem("appareil", d); }
  return d;
};

export const api = {
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password, appareil: deviceId() }).then(r => r.data),
  verifierQuestion: (challenge_token, reponse) => axios.post(`${API}/auth/question`, { challenge_token, reponse, appareil: deviceId() }).then(r => r.data),
  definirQuestions: (questions) => axios.post(`${API}/auth/questions`, { questions }).then(r => r.data),
  securite: () => axios.get(`${API}/auth/securite`).then(r => r.data),
  setSecurite: (b) => axios.put(`${API}/auth/securite`, b).then(r => r.data),
  genererMotDePasse: (uid) => axios.post(`${API}/auth/users/${uid}/mot-de-passe`).then(r => r.data),
  config: () => axios.get(`${API}/config`).then(r => r.data),
  deleteImport: (id) => axios.delete(`${API}/import/${id}`).then(r => r.data),
  ligne: (id, sheet, ligne) => axios.get(`${API}/import/${id}/sheet/${enc(sheet)}/ligne/${ligne}`).then(r => r.data),
  corrigerLigne: (id, sheet, ligne, champs, raison) => axios.put(`${API}/import/${id}/sheet/${enc(sheet)}/ligne/${ligne}`, { champs, raison }).then(r => r.data),
  supprimerLigne: (id, sheet, ligne, raison) => axios.delete(`${API}/import/${id}/sheet/${enc(sheet)}/ligne/${ligne}`, { params: { raison } }).then(r => r.data),
  annulerCorrection: (id, sheet, ligne) => axios.delete(`${API}/import/${id}/sheet/${enc(sheet)}/ligne/${ligne}/correction`).then(r => r.data),
  corrections: (id, sheet) => axios.get(`${API}/import/${id}/sheet/${enc(sheet)}/corrections`).then(r => r.data),
  journalCorrections: (q = "") => axios.get(`${API}/corrections`, { params: q ? { q } : {} }).then(r => r.data),
  apercuLot: (id, b) => axios.post(`${API}/import/${id}/lot/apercu`, b).then(r => r.data),
  appliquerLot: (id, b) => axios.post(`${API}/import/${id}/lot`, b).then(r => r.data),
  annulerLot: (id, lotId) => axios.delete(`${API}/import/${id}/lot/${lotId}`).then(r => r.data),
  copiloteSession: () => axios.get(`${API}/copilote/session`).then(r => r.data),
  copiloteChat: (body, onChunk) => fetch(`${API}/copilote/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
    body: JSON.stringify(body),
  }).then(async (res) => {
    if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || `Erreur ${res.status}`);
    const reader = res.body.getReader();
    const dec = new TextDecoder();
    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;
      onChunk(dec.decode(value, { stream: true }));
    }
    return res.headers.get("X-Session-Id");
  }),
  correctionsXlsxUrl: (q = "") => `${API}/corrections.xlsx?token=${getToken()}${q ? `&q=${enc(q)}` : ""}`,
  appareils: () => axios.get(`${API}/auth/appareils`, { params: { appareil: deviceId() } }).then(r => r.data),
  revoquerAppareil: (emp) => axios.delete(`${API}/auth/appareils/${emp}`).then(r => r.data),
  revoquerAppareils: () => axios.delete(`${API}/auth/appareils`, { params: { appareil: deviceId() } }).then(r => r.data),
  revoquerAppareilsUtilisateur: (uid) => axios.delete(`${API}/auth/users/${uid}/appareils`).then(r => r.data),
  setMaLangue: (langue) => axios.put(`${API}/auth/langue`, { langue }).then(r => r.data),
  me: () => axios.get(`${API}/auth/me`).then(r => r.data),
  logout: () => axios.post(`${API}/auth/logout`).then(r => r.data),
  changePassword: (ancien, nouveau) => axios.post(`${API}/auth/password`, { ancien, nouveau }).then(r => r.data),
  users: () => axios.get(`${API}/auth/users`).then(r => r.data),
  createUser: (b) => axios.post(`${API}/auth/users`, b).then(r => r.data),
  patchUser: (id, b) => axios.patch(`${API}/auth/users/${id}`, b).then(r => r.data),
  deleteUser: (id) => axios.delete(`${API}/auth/users/${id}`).then(r => r.data),

  preview: (file) => { const f = new FormData(); f.append("file", file); return axios.post(`${API}/import/preview`, f).then(r => r.data); },
  commit: (file) => { const f = new FormData(); f.append("file", file); return axios.post(`${API}/import/commit`, f).then(r => r.data); },
  uploadStart: (file) => axios.post(`${API}/import/upload/start`, { filename: file.name, size: file.size }).then(r => r.data),
  uploadChunk: (id, index, blob) => { const f = new FormData(); f.append("file", blob, "chunk"); return axios.post(`${API}/import/upload/${id}/chunk?index=${index}`, f, { timeout: 120000 }).then(r => r.data); },
  uploadFinish: (id) => axios.post(`${API}/import/upload/${id}/finish`).then(r => r.data),
  uploadStatus: (id) => axios.get(`${API}/import/upload/${id}`).then(r => r.data),
  uploadCommit: (id) => axios.post(`${API}/import/upload/${id}/commit`, null, { timeout: 600000 }).then(r => r.data),
  imports: () => axios.get(`${API}/imports`).then(r => r.data),
  analyse: (id, sheet) => axios.get(`${API}/import/${id}/sheet/${enc(sheet)}/analyse${sq('?')}`).then(r => r.data),
  issues: (id, sheet) => axios.get(`${API}/import/${id}/sheet/${enc(sheet)}/issues${sq('?')}`).then(r => r.data),
  map: (id, sheet) => axios.get(`${API}/import/${id}/sheet/${enc(sheet)}/map${sq('?')}`).then(r => r.data),
  setLabPosition: (nom, b) => axios.put(`${API}/laboratoires/${enc(nom)}/position`, b).then(r => r.data),
  referentiel: () => axios.get(`${API}/referentiel`).then(r => r.data),
  addStructure: (b) => axios.post(`${API}/referentiel`, b).then(r => r.data),
  setSiteMap: (b) => axios.put(`${API}/site_map`, b).then(r => r.data),
  delSiteMap: (zone, site) => axios.delete(`${API}/site_map`, { params: { zone, site } }).then(r => r.data),
  alertes: () => axios.get(`${API}/alertes`).then(r => r.data),
  genererAlerte: (envoyer) => axios.post(`${API}/alertes/generer`, null, { params: { envoyer } }).then(r => r.data),
  setAlerteDest: (uid, actif) => axios.put(`${API}/alertes/destinataires/${uid}`, null, { params: { actif } }).then(r => r.data),
  forgotPassword: (email) => axios.post(`${API}/auth/forgot-password`, { email }).then(r => r.data),
  resetPassword: (token, nouveau) => axios.post(`${API}/auth/reset-password`, { token, nouveau }).then(r => r.data),
  alertesXlsxUrl: () => `${API}/alertes/export.xlsx?token=${getToken()}`,
  alerteParams: () => axios.get(`${API}/alertes/parametres`).then(r => r.data),
  smsDest: () => axios.get(`${API}/alertes/sms`).then(r => r.data),
  addSmsDest: (b) => axios.post(`${API}/alertes/sms`, b).then(r => r.data),
  patchSmsDest: (id, b) => axios.patch(`${API}/alertes/sms/${id}`, b).then(r => r.data),
  delSmsDest: (id) => axios.delete(`${API}/alertes/sms/${id}`).then(r => r.data),
  testSmsDest: (id) => axios.post(`${API}/alertes/sms/${id}/test`).then(r => r.data),
  setAlerteParams: (b) => axios.put(`${API}/alertes/parametres`, b).then(r => r.data),
  rapports: (etat = "actifs") => axios.get(`${API}/rapports`, { params: { etat } }).then(r => r.data),
  genererRapport: (semaine) => axios.post(`${API}/rapports/generer`, null, { params: { lang: _lang, ...(semaine ? { semaine } : {}) } }).then(r => r.data),
  archiverRapport: (id) => axios.post(`${API}/rapports/${id}/archiver`).then(r => r.data),
  desarchiverRapport: (id) => axios.post(`${API}/rapports/${id}/desarchiver`).then(r => r.data),
  corbeilleRapport: (id) => axios.delete(`${API}/rapports/${id}`).then(r => r.data),
  restaurerRapport: (id) => axios.post(`${API}/rapports/${id}/restaurer`).then(r => r.data),
  viderCorbeille: () => axios.post(`${API}/rapports/corbeille/vider`).then(r => r.data),
  rapportUrl: (id) => `${API}/rapports/${id}.pdf?token=${getToken()}`,
  publicResume: () => axios.get(`${API}/public/resume`).then(r => r.data),
  methodesPdf: (body) => axios.post(`${API}/public/methodes.pdf`, body, { responseType: "blob" }).then(r => r.data),
  guideLogicielPdf: (body) => axios.post(`${API}/public/guide-logiciel.pdf`, body, { responseType: "blob" }).then(r => r.data),
  overlap: (id) => axios.get(`${API}/import/${id}/overlap`).then(r => r.data),
  schema: () => axios.get(`${API}/schema`).then(r => r.data),
  journal: () => axios.get(`${API}/journal`).then(r => r.data),
  reset: () => axios.delete(`${API}/reset`).then(r => r.data),
  saisies: () => axios.get(`${API}/saisies`).then(r => r.data),
  saisieRefs: () => axios.get(`${API}/saisies/referentiels`).then(r => r.data),
  posteInfo: () => axios.get(`${API}/postes/info`).then(r => r.data),
  posteMiseAJour: () => axios.get(`${API}/postes/mise-a-jour`).then(r => r.data),
  posteMajAppliquer: () => axios.post(`${API}/postes/mise-a-jour/appliquer`).then(r => r.data),
  posteMajEtat: () => axios.get(`${API}/postes/mise-a-jour/etat`).then(r => r.data),
  posteMajRedemarrer: () => axios.post(`${API}/postes/mise-a-jour/redemarrer`).then(r => r.data),
  installationEtat: () => axios.get(`${API}/auth/installation`).then(r => r.data),
  installationCreer: (body) => axios.post(`${API}/auth/installation`, body).then(r => r.data),
  posteEchanges: () => axios.get(`${API}/postes/echanges`).then(r => r.data),
  paquetUrl: () => `${API}/postes/paquet?token=${getToken()}`,
  telechargements: () => axios.get(`${API}/telechargements`).then(r => r.data),
  logicielPublic: () => axios.get(`${API}/public/logiciel`).then(r => r.data),
  logicielPublicUrl: (id) => `${API}/public/logiciel/${id}`,
  telechargementUrl: (id) => `${API}/telechargements/${id}?token=${getToken()}`,
  supprimerTelechargement: (id) => axios.delete(`${API}/telechargements/${id}`).then(r => r.data),
  publierTelechargement: async (file, onProgress) => {
    const { upload_id } = await axios.post(`${API}/telechargements/upload/start`, { filename: file.name, size: file.size }).then(r => r.data);
    const taille = 8 * 1024 * 1024;
    for (let i = 0, idx = 0; i < file.size; i += taille, idx++) {
      const f = new FormData(); f.append("file", file.slice(i, i + taille));
      await axios.post(`${API}/telechargements/upload/${upload_id}/chunk?index=${idx}`, f, { timeout: 600000 });
      onProgress?.(Math.min(i + taille, file.size) / file.size);
    }
    return axios.post(`${API}/telechargements/upload/${upload_id}/finish`).then(r => r.data);
  },
  importerPaquet: (file) => { const f = new FormData(); f.append("file", file); return axios.post(`${API}/postes/paquet`, f, { timeout: 300000 }).then(r => r.data); },
  createSaisie: (b) => axios.post(`${API}/saisies`, b).then(r => r.data),
  updateSaisie: (id, b) => axios.put(`${API}/saisies/${id}`, b).then(r => r.data),
  deleteSaisie: (id) => axios.delete(`${API}/saisies/${id}`).then(r => r.data),
  saisiesXlsxUrl: () => `${API}/saisies/export.xlsx?token=${getToken()}`,
  rechercher: (id) => axios.get(`${API}/echantillon/${enc(id)}`).then(r => r.data),
  rechercheListe: (params) => axios.get(`${API}/echantillon/liste`, { params }).then(r => r.data),
  rechercheXlsxUrl: (params) => `${API}/echantillon/liste.xlsx?` + new URLSearchParams({ ...Object.fromEntries(Object.entries(params).filter(([, v]) => v)), token: getToken() }).toString(),
  fichePdfUrl: (id) => `${API}/echantillon/${enc(id)}/fiche.pdf?token=${getToken()}`,
  alerteZones: () => axios.get(`${API}/alertes/zones`).then(r => r.data),
  setAlerteDestZones: (uid, zones) => axios.put(`${API}/alertes/destinataires/${uid}/zones`, { zones }).then(r => r.data),
  suggestions: (q) => axios.get(`${API}/echantillon/suggestions`, { params: { q } }).then(r => r.data),
  indicateursXlsxUrl: (id, sheet) => `${API}/import/${id}/sheet/${enc(sheet)}/indicateurs.xlsx?token=${getToken()}${sq('&')}`,
  issuesCsvUrl: (id, sheet) => `${API}/import/${id}/sheet/${enc(sheet)}/issues.csv?token=${getToken()}${sq('&')}`,
  qcXlsxUrl: (id, sheet) => `${API}/import/${id}/sheet/${enc(sheet)}/controle_qualite.xlsx?token=${getToken()}${sq('&')}`,
};

// --- formatage (reproduit la console) ---
export const serialToDate = (s) => new Date(Date.UTC(1899, 11, 30) + Math.round(s * 86400000));
export const fmtD = (s) => { if (s == null) return ""; const d = serialToDate(s); const i = d.toISOString(); return i.slice(8, 10) + "/" + i.slice(5, 7) + "/" + d.getUTCFullYear(); };
export const fr = (x, d = 1) => (x == null || isNaN(x)) ? "" : x.toLocaleString("fr-FR", { minimumFractionDigits: d, maximumFractionDigits: d });
export const pc = (x) => (x == null || isNaN(x)) ? "" : fr(100 * x, 1) + "\u00a0%";
export const hh = (x) => (x == null || isNaN(x)) ? "" : fr(x, 1) + "\u00a0h";
export const intf = (x) => (x == null || isNaN(x)) ? "0" : Math.round(x).toLocaleString("fr-FR");
export const delayColor = (h) => h == null ? "#94A3B8" : h <= 2 ? "var(--green)" : h <= 4 ? "var(--amber)" : "var(--red)";
